<template>
  <div class="sku-container">
    <el-form-item label="商品规格" required>
      <div class="d-flex sku-item">
        <div class="sku-item-list" v-for="(skuItem, index) in skuGroup" :key="index">
          <el-input v-model="skuItem.name" @change="changedSKUAttr(index)" placeholder="*">
            <el-button v-if="index !== 0" slot="append" icon="el-icon-close" @click="handleRmSku(index)"></el-button>
            <el-button v-else slot="append"></el-button>
          </el-input>
        </div>
        <el-button type="text" size="mini" icon="el-icon-plus" @click="handleAddSku">添加规格</el-button>
      </div>
      <div class="color-sliver">修改规格后，规格对应SKU的销售权重信息归零，请谨慎操作！</div>
    </el-form-item>
    <el-divider></el-divider>
    <el-form-item :label="(skuItem.name || '*')" required v-for="(skuItem, index) in skuGroup" :key="index + 's'">
      <div class="d-flex sku-item sku-item-item">
        <div class="sku-item-list" v-for="(item, itemIndex) in skuItem.items" :key="itemIndex + 'i'">
          <el-input v-model="item.name" @change="skuItemChange(index,itemIndex)" placeholder="#">
            <el-button v-if="itemIndex !== 0" slot="append" icon="el-icon-close" @click="handleRmSkuItem(index, itemIndex)"></el-button>
            <el-button v-else slot="append"></el-button>
          </el-input>
          <uploader class="mt-10" v-model="item.picture" :remove="true" @on-change="buildSkuValues" @no-remove="buildSkuValues" v-if="index == 0 && allowImage"/>
        </div>
        <el-button type="text" size="small" icon="el-icon-plus" @click="handleAddSkuItem(index)">添加{{ skuItem.name || '#' }}</el-button>
        <!-- <el-checkbox v-if="index === 0" class="ml-10 check-img" v-model="allowImage">上传图片</el-checkbox> -->
      </div>
      <div v-if="index === 0 && allowImage" class="fs-12 color-sliver">SKU图片选填，建议尺寸800*800</div>
    </el-form-item>

    <el-form-item label="" required :error="errorSKu">
      <el-tag type="warning">注意：福利券抵扣额度不能低于售价的10%，抵扣额度以实际金额为准，百分比仅做数据参考。</el-tag>
      <el-table :data="skuValues" style="width: 100%; margin-top: 10px">
        <el-table-column
          v-for="(skuItem, index) in skuGroup"
          :key="index + 's'"
          prop="specs"
          :label="skuItem.name || '*'"
          width="80"
        >
        <template slot-scope="scope">
            {{ scope.row.specs[skuItem.name] || '#' }}
          </template>
      </el-table-column>
        <el-table-column prop="shop_price" label="零售价">
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.shop_price"
              placeholder="(必填)"
              @blur="priceChange(scope.$index)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="welfare" width="200px" min-width="120px">
          <template slot="header">
            <el-tooltip
              class="item"
              effect="dark"
              content="用户购买时可以使用福利券抵扣的最大金额，最低抵扣10%"
              placement="top"
            >
              <div>
                <span>福利券抵扣</span>
                <i class="el-icon-question" />
              </div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <sku-item-welfare v-if="showWelfare" v-model="scope.row" />
          </template>
        </el-table-column>

        <el-table-column prop="real_price" align="center" label="实价">
          <template slot-scope="scope">
            <span>¥ {{realPriceList[scope.$index]}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="stock" label="库存">
          <template slot-scope="scope">
            <el-input :min="0" type="number" v-model="scope.row.stock" placeholder="(必填)"></el-input>
          </template>
        </el-table-column>
        
        <el-table-column prop="code" label="商家编码">
          <template slot-scope="scope">
            <el-input v-model="scope.row.code" maxlength="32"></el-input>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="barcode" label="条形码">
          <template slot-scope="scope">
            <el-input v-model="scope.row.barcode"></el-input>
          </template>
        </el-table-column> -->
      </el-table>
    </el-form-item>
  </div>
</template>

<script>
import Uploader from '@/components/Uploader.vue';
import SkuItemWelfare from './SkuItemWelfare';
export default {
  props: ['defaultSkus', 'error'],
  components: {
    Uploader,
    SkuItemWelfare
  },
  data() {
    return {
      skuGroup: [
        {
          name: '颜色',
          items: [ { name: '红色' } ]
        }
      ],
      skuValues:[], // SKU价格信息
      timer: null,
      allowImage: true,
      showWelfare: true
    };
  },
  created() {
    this.buildSkuValues();
  },
  watch: {
    defaultSkus (v) {
      this.skuValues = v;
      this.buildSkuSelect();
    }
  },
  computed: {
    errorSKu: function () {
      let err = '';
      (this.error || []).forEach((item, index) => {
        let _st = '';
        Object.keys(item).forEach(sku => {
          switch(sku) {
            case 'code' : _st += '商家编码：' + item[sku][0];
              break;
            case 'picture' : _st += 'SKU图片' + item[sku][0];
              break;
            case 'stock' : _st += '库存：' + item[sku][0];
              break;
            case 'shop_price' : _st += '销售价：' + item[sku][0];
              break;
          }
        })
        if (_st) {
          err += '第' + (index + 1) + '行 ' + _st;
        }
      });
      return err;
    },
    realPriceList: function () {
      return this.skuValues.map(item => {
        let amount = item.shop_price - Math.ceil(item.welfare);
        amount = Number(amount.toFixed(2));
        if (amount < 0) amount = 0;
        return amount;
      })
    }
  },
  methods: {
    priceChange(index) {
      
      clearTimeout(this.timer) 
      this.timer = setTimeout(() => {
        let currentValue = this.skuValues[index]['shop_price']
        currentValue = parseFloat(currentValue);
        currentValue = parseFloat(currentValue.toFixed(2));
        if (isNaN(currentValue)) {
          return null;
        }

        // 价格不能低于 1 元
        if (currentValue < 1) {
          this.$message.error(`零售价不可低于1元`);
          currentValue = 1;
        }

        this.skuValues[index]['shop_price'] = currentValue;
      }, 800)
    },
    getSkuValues() {
      return this.skuValues;
    },
    changedSKUAttr(index) {
      let count = 0
      let currentName = this.skuGroup[index].name
      this.skuGroup.forEach(item=>{
        if(item.name===currentName){
          count++
        }
      })
      if(count>1){
        this.$message.error(`当前商品规格已存在，请重新输入`);
        this.skuGroup[index].name = ''
        return
      }
      this.skuValues = [];
      this.buildSkuValues();
    },
    buildSkuSelect() {
      let _skuGroup = [];
      this.skuValues.forEach(valueItem => {
        Object.keys(valueItem.specs).forEach(key => {
          let issetSku = false
          _skuGroup.forEach(skuItem => {
            if (skuItem.name == key) {
              // 存在规格
              issetSku = true

              let issetItem = false;
              skuItem.items.forEach(item => {
                if (item.name == valueItem.specs[key]) {
                  issetItem = true;
                }
              })
              if (!issetItem) {
                skuItem.items.push({
                  name: valueItem.specs[key],
                  picture: valueItem.picture
                })
              }
            }
          })
          if (!issetSku) {
            _skuGroup.push({
              name: key,
              items: [{
                name: valueItem.specs[key],
                picture: valueItem.picture
              }]
            })
          }
        })
      })
      console.log(_skuGroup);

      // 重新排序，SKU数多的在前面
      let _maxItems = _skuGroup[0].items.length || 0;
      for(let i = 1; i < _skuGroup.length; i++) {
        if (_skuGroup[i].items.length > _maxItems) {
          _maxItems = _skuGroup[i].items.length;

          let _maxGroup = _skuGroup.splice(i, 1)
          _skuGroup.unshift(_maxGroup[0]);
        }
      }

      this.skuGroup = _skuGroup;
      this.buildSkuValues();
    },
    // 添加SKu信息
    nextSku(_dd, index) {
      let _cc = [];
      this.skuGroup[index].items.forEach((sku) => {
        _dd.forEach(element => {
          let a = [];
          for(var i in element){
            a.push(element[i]);
          }
          a.push(sku);
          _cc.push(a)
        });
      });
      return _cc;
    },
    // 输入具体规格参数 触发校验 并重构规格
    skuItemChange(index, itemIndex){
      let skuItem = this.skuGroup[index]
      let items = skuItem.items
      let itemName = skuItem.name
      let currentName = items[itemIndex].name
      // 如果规格不为空 校验
      if(currentName){
        // 当前规格出现次数
        let count = 0
        items.forEach(item=>{
          if(item.name === currentName){
            count++
          }
        })
        // 规格重复时 置空并返回
        if(count>1){
          this.$message.error(`当前${itemName}已存在，请重新输入`);
          this.skuGroup[index].items[itemIndex].name = ''
          return
        }
      }
      this.buildSkuValues()
    },
    // 重构SKU信息
    buildSkuValues() {
      // 清空所有价格数据
      let _skuValues = [];

      // 遍历所有SKU规格，生成一对一的数组列表
      // 形如：
      // [
      //   [ { name: '红色', picture: '' }, { name: '10L' }]
      // ]
      // 
      let _skuItemArray = [];
      this.skuGroup[0].items.forEach((sku) => {
        _skuItemArray.push([sku]);
      });

      for (let index = 1; index < this.skuGroup.length; index ++) {
        _skuItemArray = this.nextSku(_skuItemArray, index);
      }
      // 遍历一一对应的SKU数组，并向其填充
      for (let jIndex = 0; jIndex < _skuItemArray.length; jIndex++) {

        let _spec = {};
        let _pic = '';
        _skuItemArray[jIndex].forEach((ddItem, index) => {
          _spec[this.skuGroup[index].name] = ddItem.name
          // 读取第一个SKU的图片作为整个与之关联SKU的图片
          if (ddItem.picture && !_pic) _pic = ddItem.picture;
        })

        // 遍历修改之前的原始值，如果已经存在SKU信息，则使用旧数据填充
        let _isNew = true;
        this.skuValues.forEach(oldSkuValue => {
          if (this.skuIsEqual(_spec, oldSkuValue.specs)) {
            _isNew = false;
            oldSkuValue.picture = _pic;
            oldSkuValue.welfare = parseInt(oldSkuValue.welfare)
            _skuValues.push(oldSkuValue);
          }
        })
        // 如果没有在原始值中获取到数据，则新增空白的一栏
        if (_isNew) {
          _skuValues.push({
            specs: _spec,
            picture: _pic,
            stock: 0,
            shop_price: null,
            welfare: '0',
            code: ''
            // barcode: null
          })
        }
      }
      this.showWelfare = false;
      this.skuValues = _skuValues;
      this.$nextTick(() => {
        this.showWelfare = true;
      })
    },
    // 判断两个对象是否拥有相同数据
    skuIsEqual(obj1, obj2) {
      let equal = true;

      if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;

      Object.keys(obj1).forEach(key => {
        let _obj2Value = obj2[key] || null;
        if (_obj2Value !== obj1[key]) {
          equal = false;
        }
      })
      return equal;
    },
    // 添加规格
    handleAddSku() {
      if(this.skuGroup.some(item=>!item.name)){
        this.$message.error(`存在名称为空的规格时，无法添加新规格`);
        return
      }
      this.skuGroup.push({
        name: '',
        items: [
          {
            name: ''
          }
        ]
      });
      this.buildSkuValues();
    },
    // 添加规格SKU
    handleAddSkuItem(index) {
      this.skuGroup[index].items.push({
          name: ''
      })
      this.buildSkuValues();
      console.log(this.skuValues);
    },
    // 移除规格
    handleRmSku(index) {
      this.$confirm('删除当前信息会重置所有SKU信息，确认继续操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认删除',
        cancelButtonText: '取消'
      })
      .then(() => {
        this.skuGroup.splice(index, 1);
        this.buildSkuValues();
      })
      .catch(() => {});
    },
    // 移除规格SKU
    handleRmSkuItem(index, itemIndex) {
      this.$confirm('删除当前信息会重置所有SKU信息，确认继续操作？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认删除',
        cancelButtonText: '取消'
      })
      .then(() => {
        this.skuGroup[index].items.splice(itemIndex, 1);
        this.buildSkuValues();
      })
      .catch(() => {});
    }
  }
}
</script>

<style lang="scss" scoped>

.sku-container {
  // border: 1px solid #DCDFE6;
  // border-radius: 5px;
  // padding: 20px 10px;
  .sku-item {
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 5px;
    .sku-item-list {
      width: 148px;
      margin-right: 10px;
    }
  }
  .sku-item-item {
    padding: 10px;
    background-color: #f5f5f5;
  }
  ::v-deep .el-checkbox {
    font-weight: 400;
    margin-top: -5px;
  }
  ::v-deep .el-input__inner {
    border-color: #DCDFE6;
  }
  ::v-deep .el-button--default {
    padding: 11px 20px;
  }
  ::v-deep .avatar-uploader-icon {
    width: 128px;
    height: 128px;
  }
  ::v-deep .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }
  ::v-deep thead th {
    background: $slateGray;
  }
}
</style>